export enum SellLimitFieldNames {
    DAYS_FIELD_NAME = 'days',
    CLEAR_ALL_RESOURCE_CATEGORIES = 'clearAllResourceCategories',
    EXACT_RATE_IDS_FIELD_NAME = 'exactRateIds',
    LIMIT_END_FIELD_NAME = 'lastTimeUnitStartUtc',
    LIMIT_START_FIELD_NAME = 'firstTimeUnitStartUtc',
    NUMBER_OF_SPACES_FIELD_NAME = 'absolutePerTimeUnitLimit',
    RATE_GROUP_IDS_FIELD_NAME = 'rateGroupIds',
    RATE_SELECT_OPTION_FIELD_NAME = 'rateSelectOption',
    RESOURCE_CATEGORY_IDS_FIELD_NAME = 'resourceCategoryIds',
    SPACE_SELECT_OPTION_FIELD_NAME = 'spaceSelectOption',
}
